export default "__VITE_ASSET__93afc783__"